import React, { useContext } from 'react';
import { IMetaResource } from '@enuan/chat__utils';
import { ReactComponent as DownloadIcon } from '@/assets/download.svg';
import { instanceContext } from '../../../../contexts/instance';
import { useIntl } from 'react-intl';
import { mediaMessages } from '../i18n';

export const Download = ({ data }: { data: IMetaResource }) => {
	const intl = useIntl();
	const message__download = intl.formatMessage(mediaMessages.download);
	const { instance: provider } = useContext(instanceContext);
	const url = provider?.getResourceUrl(data);
	if (!url) return null;
	return (
		<a
			className="message__download"
			download={data.name ?? true}
			href={url}
			title={message__download}
		>
			<DownloadIcon />
		</a>
	);
};
